import { debounce } from "lodash-es";

// ������� ��� ������������ ������� ������� hideScroll � showScroll
let counter = 0;

// ������� ���������� ������ body � �������������� debounce
const update = debounce(function () {
    // ���� ������� ������ ����, ��������� ����� "no-scroll", ����� ������� ���
    if (counter > 0) {
        document.body.classList.add("no-scroll");
    } else {
        document.body.classList.remove("no-scroll");
    }
}, 30);

// �������������� ������ � �������� hideScroll � showScroll
export default {
    /**
     * ����������� ������� � ��������� ������� ����������.
     */
    hideScroll() {
        counter++;
        update();
    },
    /**
     * ��������� ������� � ��������� ������� ����������.
     */
    showScroll() {
        counter--;
        update();
    }
};
